"use client"

import { useState, useEffect } from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import axios from "axios";
import { toast } from 'sonner';
import { setUserData } from "@/store/mainSlice";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from 'next/navigation';
import Select from 'react-select';
import countryJson from "./country.json"
import { email } from "zod/v4";
import { setFetchUserData } from "@/store/mainSlice";



export function AuthForm({ setIsSuccessful, children, defaultEmail = "", handleClose }) {
  const [formData, setFormData] = useState({});
  const dispatch = useDispatch()
  const router = useRouter()
  const { userData } = useSelector((state) => state.main)

  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setIsDark(document.documentElement.classList.contains("dark"));
    }
  }, []);


  const handleChange = (e) => {
    const key = e.target.name;
    const value = e.target.value;
    setFormData((old) => {
      return {
        ...old,
        [key]: value
      }
    });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
   

    if (!formData.old_password) {
      toast.error("Old Password is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }
    if (!formData.new_password) {
      toast.error("New Password is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }
    if (!formData.confirm_password) {
      toast.error("Confirm Password is required!", {
        style: { color: "red" },
        position: "top-center",
        iconTheme: { primary: "red", secondary: "#fff" }
      });
      return;
    }


    setIsSuccessful(true)
    try {
      let datasend = {
        old_password: formData.old_password,
        new_password: formData.new_password,
        confirm_password: formData.confirm_password,
        userId: userData._id
      };
      const res = await axios.post(process.env.NEXT_PUBLIC_APP_CHANGE_PASSWORD, datasend,
        {
          headers: {
            "x-auth-token": localStorage.getItem("authToken"),
            // "Content-Type": "multipart/form-data",
            "Content-Type": "application/json",
          },
        }
      );
      // if (res.data.status == 1 && res.data.isProfileComplete === true) {
      if (res.data) {
      toast.success("Password Changed Successful.", {
        style: { color: "green" }, // only text color
        position: "top-center",
        iconTheme: { primary: "green", secondary: "#fff" },
      });
      handleClose()
      }
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userId");
        toast.error("Session expired. Redirecting to login.", {
          style: { color: "red" },
          position: "top-center",
          iconTheme: { primary: "red", secondary: "#fff" },
        });
        router.push("/login");
      } else {
        toast.error(err?.response?.data?.message || "Something went wrong", {
          style: { color: "red" },
          position: "top-center",
          iconTheme: { primary: "red", secondary: "#fff" },
        });
      }
    } finally {
      setIsSuccessful(false)
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col gap-4 sm:px-0 px-0"
    >
      <div className="flex flex-col gap-2">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="name"
        >
          Enter Old Password<span className="text-red-500">*</span>
        </Label>

        <Input
          autoComplete="name"
          autoFocus
          className="bg-muted text-md md:text-sm h-12 w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
          id="old_password"
          name="old_password"
          placeholder="Enter old password"
          required
          type="password"
          value={formData.old_password}
          onChange={handleChange}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="name"
        >
          Enter New Password<span className="text-red-500">*</span>
        </Label>

        <Input
          autoComplete="name"
          autoFocus
          className="bg-muted text-md md:text-sm h-12 w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
          id="name"
          name="new_password"
          placeholder="Enter new password"
          required
          type="password"
          value={formData.new_password}
          onChange={handleChange}
        />
      </div>
      <div className="flex flex-col gap-2">
        <Label
          className="font-normal text-zinc-600 dark:text-zinc-400"
          htmlFor="name"
        >
          Enter Confirm Password<span className="text-red-500">*</span>
        </Label>

        <Input
          autoComplete="name"
          autoFocus
          className="bg-muted text-md md:text-sm h-12 w-full rounded-xl dark:bg-neutral-800/80 bg-white border border-white/10 p-3 text-sm focus:ring-2 focus:ring-white/30"
          id="name"
          name="confirm_password"
          placeholder="Enter confirm password"
          required
          type="password"
          value={formData.confirm_password}
          onChange={handleChange}
        />
      </div>


      {children}
    </form>
  );
}
